import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import { forgotEmailPassword, forgetPassword } from "../../../api/customer";
import resetPasswordImage from "../../../assets/images/auth/reset-password.png";
import WebsiteLogo from "../../../helpers/WebsiteLogo";
import { apiErrorHandler, detectLoginMethod, last_logged_in_username_key } from "../../../helpers/common";
import { CustomSnackbar } from "../../../helpers/CustomSnackbar";
import VerifyEmail from "../SignUp/VerifyEmail";
import VerifyMobile from "./VerifyMobile";

const ResetPassword = () => {
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [openVerifyOtp, setOpenVerifyOtp] = useState(false);
  const [inputType, setInputType] = useState(null); // "email" or "mobile_number"

  const onFormSubmit = async (e) => {
    e.preventDefault();
    
    if (!inputValue) {
      CustomSnackbar.warning("Please enter your email or mobile number");
      return;
    }

    const loginMethod = detectLoginMethod(inputValue);
    if (!loginMethod) {
      CustomSnackbar.warning("Please enter a valid email address or mobile number");
      return;
    }

    try {
      setIsLoading(true);
      setInputType(loginMethod);
      
      let response;
      if (loginMethod === "email") {
        response = await forgotEmailPassword({ email: inputValue });
      } else {
        response = await forgetPassword({ mobile_number: inputValue });
      }


      localStorage.setItem(last_logged_in_username_key, inputValue);
      
      CustomSnackbar.success(response?.data?.message);
      setOpenVerifyOtp(true);
    } catch (error) {
      apiErrorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const username = localStorage.getItem(last_logged_in_username_key);

    if (username) {
      setInputValue(username);
    }
  }, [setInputValue]);

  return (
    <React.Fragment>
      <div>
        <div className='main-content'>
          <div className='page-content'>
            <Helmet>
              <title>Reset Password | Jobseekers Page </title>
            </Helmet>
            <section className='bg-auth'>
              <Container>
                <Row className='justify-content-center'>
                  <Col xl={12} lg={12}>
                    <Card className='auth-box'>
                      <Row className='g-0'>
                        <Col lg={6} className='text-center'>
                          <CardBody className='p-4'>
                            <Link to='/'>
                              <WebsiteLogo height='28' />
                            </Link>
                            <div className='mt-5'>
                              <img
                                src={resetPasswordImage}
                                alt=''
                                className='img-fluid'
                              />
                            </div>
                          </CardBody>
                        </Col>
                        <Col lg={6}>
                          <CardBody className='auth-content p-5 h-100 text-white w-100'>
                            {openVerifyOtp ? (
                              inputType === "email" ? (
                                <VerifyEmail formData={{email: inputValue}} source="resetPassword" />
                              ) : (
                                <VerifyMobile formData={{mobile_number: inputValue}} />
                              )
                            ) : (
                              <>
                                <div className='text-center mb-4'>
                                  <h4 className='verification-title'>Reset Password</h4>
                                  <p className='text-white-50'>
                                    Reset your password with Jobseekers Page.
                                  </p>
                                </div>
                                <Form
                                  className='auth-form text-white w-100'
                                  onSubmit={onFormSubmit}
                                >
                                  <div className='mb-4'>
                                    <label
                                      className='form-label'
                                      htmlFor='inputValue'
                                    >
                                      Email or Mobile Number
                                    </label>
                                    <Input
                                      type='text'
                                      className='form-control'
                                      id='inputValue'
                                      value={inputValue}
                                      onChange={(e) => setInputValue(e.target.value)}
                                      placeholder='Enter your email or mobile number'
                                    />
                                  </div>
                                  <div className='mt-3'>
                                    {isLoading ? (
                                      <button
                                        className='btn btn-white w-100 disabled'
                                        type='button'
                                      >
                                        Send OTP <Spinner size='sm' />
                                      </button>
                                    ) : (
                                      <button
                                        type='submit'
                                        className='btn btn-white w-100'
                                      >
                                        Send OTP
                                      </button>
                                    )}
                                  </div>
                                </Form>
                                <div className='mt-5 text-center text-white-50'>
                                  <p>
                                    Remembered It ?{" "}
                                    <Link
                                      to='/signin'
                                      className='fw-medium text-white text-decoration-underline'
                                    >
                                      {" "}
                                      Go to Login{" "}
                                    </Link>
                                  </p>
                                </div>
                              </>
                            )}
                          </CardBody>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
